import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AccountOpeningForm from './pages/AccountOpeningForm';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<AccountOpeningForm />} />
      </Routes>
    </Router>
  );
}

export default App;